import * as sagaEffects from 'redux-saga/effects';

import { startSubmit, stopSubmit } from 'redux-form';
import { getFirebase } from 'react-redux-firebase';

import * as loglevel from 'config/loglevel';

import types from '../actionTypes';

import { forms } from '../config';

const { takeEvery, call, put } = sagaEffects;
function* handler({ payload }) {
    const firebase = getFirebase();
    try {
        yield put(startSubmit(forms.login));
        yield call([firebase.auth(), firebase.auth().signInWithEmailAndPassword], payload.email, payload.password);
        yield put(stopSubmit(forms.login));
    } catch (e) {
        yield put(
            stopSubmit(forms.login, {
                _error: 'errors.login',
            }),
        );
        loglevel.error(e);
    }
}

export default function* () {
    yield takeEvery(types.LOGIN_REQUEST, handler);
}
